import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Col, Row } from 'antd';

import NaStatusColumn from '@totem/components/unauthenticated/ticketing/details/tasks/NaTaskStatusColumn';

const NaTaskKanbanBoard = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Row gutter={[16, 16]}>
        <Col span={5}>
          <NaStatusColumn status={'PENDING'} color={'#bf00ff'} />
          <NaStatusColumn status={'REOPENED'} color={'#F33A6A'} />
          <NaStatusColumn status={'BLOCKED'} color={'#D22B2B'} />
        </Col>
        <Col span={5}>
          <NaStatusColumn status={'SCHEDULED'} color={'#00FFFF'} />
          <NaStatusColumn status={'WAITING'} color={'#FFA500'} />
          <NaStatusColumn status={'ON HOLD'} color={'#FF5F1F'} />
        </Col>
        <Col span={5}>
          <NaStatusColumn status={'IN PROGRESS'} color={'#00bfff'} />
        </Col>
        <Col span={5}>
          <NaStatusColumn status={'REVIEW'} color={'#FFC000'} />
          <NaStatusColumn status={'APPROVED'} color={'#228B22'} />
          <NaStatusColumn status={'REJECTED'} color={'#B80F0A'} />
        </Col>
        <Col span={4}>
          <NaStatusColumn status={'COMPLETED'} color={'#228B22'} />
          <NaStatusColumn status={'CANCELED'} color={'#71797E'} />
        </Col>
      </Row>
    </DndProvider>
  );
};

export default NaTaskKanbanBoard;
